import {combineReducers} from 'redux';

import {TinyIntroduction} from './auth';
import type {TinyIntroState} from './auth';
import {connectedFormsReducer} from './connected-forms';
import type {ConnectedFormsState} from './connected-forms';
import {creatorReducer} from './creator';
import type {CreatorState} from './creator';
import {emailComposerReducer, emailReplyReducer} from './email';
import type {EmailComposerState, EmailReplyState} from './email';
import {visitorsSidebarReducer} from './email-marketing/visitors/visitors-sidebar';
import type {VisitorsSidebarState} from './email-marketing/visitors/visitors-sidebar';
import {glossaryReducer} from './glossary/redux';
import type {GlossaryState} from './glossary/redux';
import {
    chatReducer,
    smsReducer,
    facebookReducer,
    instagramReducer,
    chatbotReducer,
    whatsappReducer,
} from './inbox/dashboard/report';
import type {
    ChatState,
    SMSState,
    FacebookState,
    InstagramState,
    ChatbotState,
    WhatsAppState,
} from './inbox/dashboard/report';
import {limitsReducer} from './limits';
import type {LimitsState} from './limits';
import {messagesReducer} from './messages';
import type {MessagesState} from './messages';
import {onboardingReducer} from './onboarding/onboarding-checklist/redux';
import type {OnboardingState} from './onboarding/onboarding-checklist/redux';
import {openableModalsReducer} from './openable-modals';
import type {OpenableModalsState} from './openable-modals';
import {peopleIqReducer} from './people-iq/redux';
import type {PeopleIqState} from './people-iq/redux';
import {
    engagementLeadsReducer,
    engagementSalesReducer,
    widgetOpensReducer,
    completedActionsReducer,
} from './reports/engagement';
import type {
    EngagementLeadsState,
    EngagementSalesState,
    WidgetOpensState,
    CompletedActionsState,
} from './reports/engagement';
import {SalesAutomationUi} from './sales-automation';
import type {SalesAutomationUiState} from './sales-automation';
import {sidebarReducer} from './sidebar/sidebar-reducer';
import type {SidebarState} from './sidebar/sidebar-reducer';
import {tasksReducer} from './tasks';
import type {CreatorTasksState} from './tasks';

export type UiState = {
    creator: CreatorState;
    tasks: CreatorTasksState;
    salesAutomation: SalesAutomationUiState;
    tinyIntroduction: TinyIntroState;
    sidebar: SidebarState;
    emailComposer: EmailComposerState;
    emailReply: EmailReplyState;
    messages: MessagesState;
    connectedForms: ConnectedFormsState;
    openableModals: OpenableModalsState;
    visitorsSidebar: VisitorsSidebarState;
    limits: LimitsState;
    glossary: GlossaryState;
    onboarding: OnboardingState;
    peopleIq: PeopleIqState;
    chat: ChatState;
    sms: SMSState;
    facebook: FacebookState;
    instagram: InstagramState;
    chatbot: ChatbotState;
    whatsapp: WhatsAppState;
    engagementLeads: EngagementLeadsState;
    engagementSales: EngagementSalesState;
    widgetOpens: WidgetOpensState;
    completedActions: CompletedActionsState;
};

export const uiReducer = combineReducers({
    creator: creatorReducer,
    tasks: tasksReducer,
    salesAutomation: SalesAutomationUi.uiReducer,
    tinyIntroduction: TinyIntroduction.tinyIntroReducer,
    sidebar: sidebarReducer,
    emailComposer: emailComposerReducer,
    emailReply: emailReplyReducer,
    messages: messagesReducer,
    connectedForms: connectedFormsReducer,
    openableModals: openableModalsReducer,
    visitorsSidebar: visitorsSidebarReducer,
    limits: limitsReducer,
    glossary: glossaryReducer,
    onboarding: onboardingReducer,
    peopleIq: peopleIqReducer,
    chat: chatReducer,
    sms: smsReducer,
    facebook: facebookReducer,
    instagram: instagramReducer,
    chatbot: chatbotReducer,
    whatsapp: whatsappReducer,
    engagementLeads: engagementLeadsReducer,
    engagementSales: engagementSalesReducer,
    widgetOpens: widgetOpensReducer,
    completedActions: completedActionsReducer,
});
